<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>خدمات ما   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>کاشت ابرو به عملی گفته می شود که در آن گرافت ها یا فولیکول های مو از ناحیه موهای سر برداشته می شوند. سپس این گرافت ها در ناحیه ابرو کاشت داده شده تا در این محل رشد کنند. بنابراین موهای جدید ابرو از طریق گرافت های پیوند خورده رشد خواهند کرد. در این عمل از موهای طبیعی سر خود بیمار برای پیوند زدن استفاده می کنند.   </template>
                </m-h4><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/\u06a9\u0627\u0634\u062a_\u0627\u0628\u0631\u0648\/IMG_7555.JPG","alt":"arair"},...{}}' :style='"height:900px;\nobject-fit:contain;"' class="img-fluid mx-auto col-12" ></m-img></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
